// lodash
import _replace from 'lodash/replace';

// utils
import { getCurrencyCode } from '@tekion/tekion-i18n/utils';

// constants
import { CURRENCY_VALUE_PRECISION } from '../decimalInput.constants';
export var getFormattedNumberWithCommas = function getFormattedNumberWithCommas(value) {
  var formattedValue = _replace(value, /\B(?=(\d{3})+(?!\d))/g, ',');
  return formattedValue;
};
export var getFormattedCurrencyValue = function getFormattedCurrencyValue(value, locale) {
  var currencyCode = getCurrencyCode();
  var formattedCurrencyValueWithSymbol = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: CURRENCY_VALUE_PRECISION
  }).format(value);
  /**
   * This is done in order to remove the currency symbol. Intl.NumberFormat adds a currency symbol when formatting into a currency.
   */
  var formattedCurrencyValueWithoutSymbol = _replace(formattedCurrencyValueWithSymbol, /[^0-9.,-]/g, '');
  return formattedCurrencyValueWithoutSymbol;
};